// C9 : téléphone affiché dans les tableaux de l'Accueil et de la Caisse (cartes Rendez-vous et Patients, page Rendez-vous).
// Règle : le téléphone du patient s'il est renseigné ; sinon celui de son accompagnant suivi de la filiation entre
// parenthèses (« +22890246578 (Mère) », le numéro seul si la filiation est inconnue) ; sinon « — ».
// La Clinique rend « telephone_affiche » déjà formaté selon cette règle (et « telephone_source ») : l'écran l'affiche tel
// quel. Face à une Clinique plus ancienne, la même règle s'applique aux clés historiques (téléphone du patient, puis
// accompagnant_telephone / accompagnant_filiation quand elles existent).

const texte = valeur => (valeur === null || valeur === undefined ? '' : String(valeur).trim())

// cle_patient : clé du téléphone propre du patient dans la ligne (« telephone » pour un rendez-vous, « patient_telephone »
// pour la liste des patients)
export function telephone_affiche(ligne, cle_patient) {
    if (!ligne) return '—'
    const affiche = texte(ligne.telephone_affiche)
    if (affiche) return affiche
    const propre = texte(ligne[cle_patient || 'telephone'])
    if (propre) return propre
    const accompagnant = texte(ligne.accompagnant_telephone)
    if (!accompagnant) return '—'
    const filiation = texte(ligne.accompagnant_filiation)
    return filiation ? accompagnant + ' (' + filiation + ')' : accompagnant
}

// « patient », « accompagnant » ou « » (aucun numéro)
export function telephone_source(ligne, cle_patient) {
    if (!ligne) return ''
    const source = texte(ligne.telephone_source)
    if (source === 'patient' || source === 'accompagnant') return source
    if (texte(ligne[cle_patient || 'telephone'])) return 'patient'
    return texte(ligne.accompagnant_telephone) ? 'accompagnant' : ''
}

// Info-bulle de la cellule : précise que le numéro est celui de l'accompagnant
export function titre_telephone(ligne, cle_patient) {
    return telephone_source(ligne, cle_patient) === 'accompagnant' ? 'Téléphone de l\'accompagnant' : null
}
